import 'jquery-validation';
import './form-styler'
import Inputmask from "inputmask";
import numberInput from './number-input';

$.extend($.validator.messages, {
    required: "Заполните поле",
    remote: "Пожалуйста, введите правильное значение.",
    email: "Неверный формат",
    url: "Пожалуйста, введите корректный URL.",
    date: "Пожалуйста, введите корректную дату.",
    dateISO: "Пожалуйста, введите корректную дату в формате ISO.",
    number: "Пожалуйста, введите число.",
    digits: "Пожалуйста, вводите только цифры.",
    creditcard: "Пожалуйста, введите правильный номер кредитной карты.",
    equalTo: "Пожалуйста, введите такое же значение ещё раз.",
    extension: "Пожалуйста, выберите файл с правильным расширением.",
    maxlength: $.validator.format("Пожалуйста, введите не больше {0} символов."),
    minlength: $.validator.format("Пожалуйста, введите не меньше {0} символов."),
    rangelength: $.validator.format("Пожалуйста, введите значение длиной от {0} до {1} символов."),
    range: $.validator.format("Пожалуйста, введите число от {0} до {1}."),
    max: $.validator.format("Пожалуйста, введите число, меньшее или равное {0}."),
    min: $.validator.format("Пожалуйста, введите число, большее или равное {0}.")
});


export default function () {
    function initForms(){
        $('.js-validate-form').each(function () {
            var validator = $(this).validate();

            $(this).find(':required').on('keyup', function () {
                validator.element( $(this));
            })
        });


        $('.js-custom-select, input:file').styler({
            fileBrowse: 'Выберите файл',
            selectSmartPositioning: false
        });

        numberInput();

        Inputmask({"mask": "+7 (999) 999-99-99" }).mask('.js-phone-input');
    }

    initForms();
}
